import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { LandingToolbarComponent } from './landing-components/landing-toolbar/landing-toolbar.component';
import { LandingContentComponent } from './landing-components/landing-content/landing-content.component';
import { LandingFooterComponent } from './landing-components/landing-footer/landing-footer.component';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    LandingToolbarComponent,
    LandingFooterComponent,
    LandingContentComponent
  ],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss', '../app.component.scss']
})
export class LandingPageComponent {
  
}
